/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCallsByIdsRequest
 */
export interface DeleteCallsByIdsRequest {
    /**
     * Campaign ID
     * @type {number}
     * @memberof DeleteCallsByIdsRequest
     */
    campaignId?: number;
    /**
     * Array of call IDs to delete
     * @type {Array<number>}
     * @memberof DeleteCallsByIdsRequest
     */
    callIds?: Array<number>;
}

/**
 * Check if a given object implements the DeleteCallsByIdsRequest interface.
 */
export function instanceOfDeleteCallsByIdsRequest(value: object): value is DeleteCallsByIdsRequest {
    return true;
}

export function DeleteCallsByIdsRequestFromJSON(json: any): DeleteCallsByIdsRequest {
    return DeleteCallsByIdsRequestFromJSONTyped(json, false);
}

export function DeleteCallsByIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCallsByIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'callIds': json['callIds'] == null ? undefined : json['callIds'],
    };
}

export function DeleteCallsByIdsRequestToJSON(json: any): DeleteCallsByIdsRequest {
    return DeleteCallsByIdsRequestToJSONTyped(json, false);
}

export function DeleteCallsByIdsRequestToJSONTyped(value?: DeleteCallsByIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'callIds': value['callIds'],
    };
}

